"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'app.intext.code': 'CODE',
};
